import { render, staticRenderFns } from "./StatisticalAnalysisBasedSheet.vue?vue&type=template&id=63dba463"
import script from "./StatisticalAnalysisBasedSheet.vue?vue&type=script&lang=js"
export * from "./StatisticalAnalysisBasedSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports